import _defineProperty from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createContext, useCallback, useEffect, useMemo } from "react";
import { ApolloError } from "@apollo/client";
import { useRouter } from "next/router";
import { embeddedConfig } from "@catchoftheday/env-config";
import { cookies, useIsSSR } from "@catchoftheday/utilities";
import { useExperimentsQuery } from "../../generated/graphql";
import { appKeys, experimentsMap } from "./experimentList";
import { fireABEvents } from "./utils";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var AppExperimentContext = /*#__PURE__*/createContext({
  getExperiments: function getExperiments() {
    return {
      experiments: [],
      loading: false
    };
  }
});
export var AppExperimentProvider = function AppExperimentProvider(_ref) {
  var forwardHeaders = _ref.forwardHeaders,
      _ref$ssr = _ref.ssr,
      ssr = _ref$ssr === void 0 ? false : _ref$ssr,
      children = _ref.children;
  var _ref2 = embeddedConfig,
      APP_NAME = _ref2.APP_NAME; // Fallback to "fallback" app if APP_NAME is not defined or not in the list
  // for in case if it's set to an invalid value in Vault

  var app = APP_NAME && appKeys.includes(APP_NAME) ? APP_NAME : "fallback";
  var experimentsInApp = experimentsMap[app];
  var router = useRouter();
  var isSSR = useIsSSR();

  var _useExperimentsQuery = useExperimentsQuery(_objectSpread({
    variables: {
      input: {
        experiments: experimentsInApp
      }
    },
    skip: !experimentsInApp.length,
    ssr: ssr
  }, isSSR && forwardHeaders ? {
    context: {
      headers: forwardHeaders
    }
  } : {})),
      data = _useExperimentsQuery.data,
      loading = _useExperimentsQuery.loading,
      error = _useExperimentsQuery.error;

  var experiments = useMemo(function () {
    return (data === null || data === void 0 ? void 0 : data.experiments.experiments) || [];
  }, [data === null || data === void 0 ? void 0 : data.experiments.experiments]);
  var getExperiments = useCallback(function (experimentKeys) {
    var matchedExperiments = experimentKeys.map(function (key) {
      return experiments.find(function (exp) {
        return exp.experiment === key;
      }) || null;
    }); // Warn if requested experiments are not found in the app experiment list

    experimentKeys.forEach(function (exp) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (!experimentsInApp.includes(exp)) {
        console.error("\uD83D\uDCA5 Experiment ".concat(exp, " is not found in ").concat(app, ". Please make sure it is added to experimentList.ts."));
      }
    });
    return {
      experiments: matchedExperiments,
      loading: loading,
      error: error
    };
  }, [loading, error, experiments, experimentsInApp, app]);
  useEffect(function () {
    // Fire AB events whenever the pathname changes
    if (experiments.length) {
      // Wait for Snowplow to initialize
      setTimeout(function () {
        fireABEvents(experiments);
      }, 1000);
    }
  }, [experimentsInApp.length, experiments, router.pathname]);
  useEffect(function () {
    // As soon as JavaScript kicks in, set catch-AB cookies for each experiment received
    if (true && !!experiments.length) {
      experiments.filter(function (exp) {
        return !!exp.id;
      }).forEach(function (exp) {
        if (exp.active) {
          cookies.set("catch-AB-".concat(exp.id), "".concat(exp.bucket), {
            expires: 60
          });
        } else {
          cookies.remove("catch-AB-".concat(exp.id));
        }
      });
    }
  }, [experiments]);
  return ___EmotionJSX(AppExperimentContext.Provider, {
    value: {
      getExperiments: getExperiments
    }
  }, children);
};
/**
 * Mock experiment provider for testing
 */

export var MockExperimentProvider = function MockExperimentProvider(_ref3) {
  var _ref3$mockExperiments = _ref3.mockExperiments,
      mockExperiments = _ref3$mockExperiments === void 0 ? [] : _ref3$mockExperiments,
      _ref3$loading = _ref3.loading,
      loading = _ref3$loading === void 0 ? false : _ref3$loading,
      error = _ref3.error,
      children = _ref3.children;

  var getExperiments = function getExperiments(experimentKeys) {
    var experiments = experimentKeys.map(function (key) {
      return mockExperiments.find(function (exp) {
        return exp.experiment === key;
      }) || null;
    });
    return {
      experiments: experiments,
      loading: loading,
      error: error ? new ApolloError({
        networkError: error
      }) : undefined
    };
  };

  return ___EmotionJSX(AppExperimentContext.Provider, {
    value: {
      getExperiments: getExperiments
    }
  }, children);
};